import { Button } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { connect } from "react-redux";
import {
	changeHoofdgroep,
	changeSubgroep,
} from "../../services/currentInformation/actions";
import "./Home.scss";

function HorizontalMenuScroll(props) {
	const [selected, setSelected] = useState([]);
	const [position, setPosition] = useState(0);
	const { data, title, type } = props;
	const isItemSelected = (id) => !!selected.find((el) => el === id);

	const apiRef = useRef();
	useEffect(() => {
		// apiRef.current?.scrollToItem?.(apiRef.current?.getItemElementById(3));

		const pos = data
			.map((e) => e.main_group_id)
			.indexOf(props.currentHoofdgroup.id);
		apiRef.current?.scrollToItem?.(apiRef.current?.getItemElementById(pos + 1));
	}, [props.currentHoofdgroup]);
	return (
		<div>
			<h2 style={{ marginBottom: 0, fontSize: 15 }}>{title}</h2>

			<ScrollMenu apiRef={apiRef}>
				{data !== ""
					? data?.map((item, i) => (
							<Item
								key={i}
								name={item}
								type={type}
								currentHoofdgroup={props.currentHoofdgroup}
								currentSubgroup={props.currentSubgroup}
								changeHoofdgroep={props.changeHoofdgroep}
								changeSubgroep={props.changeSubgroep}
							/>
					  ))
					: null}
			</ScrollMenu>
		</div>
	);
}

function Item(props) {
	if (props.type === "Main Group") {
		return (
			<Button
				style={
					props.name.main_group_name == props.currentHoofdgroup.name
						? {
								border: 0,
								minWidth: 150,
								height: 60,
								padding: "10px",
								margin: "10px 5px",
								color: "#ffffff",
								backgroundColor: "#e67e22",
								borderRadius: "4px",
						  }
						: {
								border: 0,
								minWidth: 150,
								height: 60,
								padding: "10px",
								margin: "10px 5px",
								color: "#ffffff",
								backgroundColor: "#f6ceac",
								borderRadius: "4px",
						  }
				}
				onClick={() => {
					props.changeHoofdgroep({
						name: props.name.main_group_name,
						id: props.name.main_group_id,
					});
					props.changeSubgroep("");
				}}
			>
				{props.name.main_group_name}
			</Button>
		);
	}
}

function mapStateToProps(state) {
	return {
		loginSuccesful: state.login.data.loginSuccesful,
		identifyInfo: state.identify.identifyInfo,
		currentHoofdgroup: state.currentInformation.current_hoofdgroup,
		currentSubgroup: state.currentInformation.current_subgroup,
	};
}

export default connect(mapStateToProps, { changeHoofdgroep, changeSubgroep })(
	HorizontalMenuScroll
);
